<template>
    <div class="sign">
        <h2>注册中心</h2>
        <el-form ref="signForm" :model="signForm" :rules="signRules" label-width="100px">
            <!-- <el-form-item label="用户名" prop="username">
                <el-input v-model="signForm.username"></el-input>
            </el-form-item> -->
            <el-form-item label="姓名" prop="name">
                <el-input v-model="signForm.name"></el-input>
            </el-form-item>
            <el-form-item label="电话号码" prop="mobile">
                <el-input v-model="signForm.mobile"></el-input>
            </el-form-item>
            <el-form-item label="密码" prop="password">
                <el-input type="password" v-model="signForm.password"></el-input>
            </el-form-item>
            <el-form-item label="确认密码" prop="confirmPassword">
                <el-input type="password" v-model="signForm.confirmPassword"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="sign">注册</el-button>
                <el-button type="info" @click="goback">取消注册</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import userApi from "@/api/user";
import md5 from "js-md5";

export default {
    name: "Sign",
    data() {
        return {
            signForm: {
                username: '',
                name: '',
                mobile: '',
                password: '',
                confirmPassword: ''
            },
            signRules: {
                username: [
                    { required: true, message: '请输入用户名', trigger: 'blur' }
                ],
                name: [
                    { required: true, message: '请输入姓名', trigger: 'blur' }
                ],
                mobile: [
                    { required: true, message: '请输入电话号码', trigger: 'blur' },
                    { pattern: /^1[3456789]\d{9}$/, message: '请输入正确的电话号码', trigger: 'blur' }
                ],
                password: [
                    { required: true, message: '请输入密码', trigger: 'blur' },
                    { min: 6, message: '密码长度不能少于6位', trigger: 'blur' }
                ],
                confirmPassword: [
                    { required: true, message: '请确认密码', trigger: 'blur' },
                    { validator: this.validateConfirmPassword, trigger: 'blur' }
                ]
            }
        };
    },
    methods: {
        sign() {
            this.$refs.signForm.validate((valid) => {
                if (valid) {
                    this.loading = true;
                    userApi
                        .sign({
                            id: this.signForm.name,
                            name: this.signForm.name,
                            password: md5(this.signForm.password),
                            mobile: this.signForm.mobile
                        })
                        .then((res) => {
                            if (res.data.code == 200) {
                                this.$message({
                                    message: "注册成功",
                                    type: "success",
                                });
                                this.$router.push({ path: "/login" });
                            } else {
                                this.$message.error(res.data.msg);
                            }
                            this.loading = false;
                        })
                        .catch(() => {
                            this.loading = false;
                        });
                } else {
                    return false;
                }
            });
        },
        validateConfirmPassword(rule, value, callback) {
            if (value !== this.signForm.password) {
                callback(new Error('两次输入的密码不一致'));
            } else {
                callback();
            }
        },
        goback() {
            this.$router.push({ path: "/login" });
        }
    }
};
</script>

<style scoped>
.sign {
    max-width: 400px;
    margin: 0 auto;
    padding: 20px;
}

h2 {
    text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/sign.vue